exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2g5ddylTl8ESNaQNxBRlua{width:300px}html[dir] ._2g5ddylTl8ESNaQNxBRlua{background-color:\"[theme:white, default:#ffffff]\"}._3CUjhN5VV8JdbWxqenP7dj{-webkit-animation:none!important;animation:none!important}._3jqGq225-fH7BJqmxMslH7{max-height:470px;overflow-x:hidden}._1ERhPglYalwzOWP10nHzY1{overflow:hidden}.DyYFMlp7ZVlVjWFmfRZ1o{height:28px}html[dir=ltr] .DyYFMlp7ZVlVjWFmfRZ1o{padding-left:14px}html[dir=rtl] .DyYFMlp7ZVlVjWFmfRZ1o{padding-right:14px}._2Q_cZepdMlwER2-5S5nISw{font-size:12px;font-weight:400;color:\"[theme:themePrimary, default:#0078D4]\";line-height:1;display:inline-block}html[dir] ._2Q_cZepdMlwER2-5S5nISw{padding-top:8px}", ""]);

// exports
exports.locals = {
	"callout": "_2g5ddylTl8ESNaQNxBRlua",
	"animationStop": "_3CUjhN5VV8JdbWxqenP7dj",
	"scrollContainer": "_3jqGq225-fH7BJqmxMslH7",
	"recipientCollection": "_1ERhPglYalwzOWP10nHzY1",
	"suggestedContactsHeaderBox": "DyYFMlp7ZVlVjWFmfRZ1o",
	"suggestedContactsText": "_2Q_cZepdMlwER2-5S5nISw"
};